export { default } from './SliderBlock'
